import { PLACEHOLDER, STORM_FILE_ENVIRONMENT_IMAGE } from "theme/config/constants";
import { imgixSrc, stormSrc } from "core-web/libs/image";

import PropTypes from "prop-types";
import React from "react";
import VideoPlayIcon from "theme/components/icons/VideoPlayIcon";
import colors from "theme/config/colors";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";

const Button = styled("button")`
    position: relative;
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    padding: 10px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.neutral_200};
    color: ${({ theme }) => theme.colors.black_70};

    &:active > *,
    &:focus > * {
        outline: 0;
    }

    &.active {
        border: 1px solid ${colors.black_70};
    }
`;

const StyledVideoPlayIcon = styled(VideoPlayIcon)`
    position: absolute;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 3;
    border: none;
`;

const VideoOverlay = styled("div")`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
`;

const Video = styled("video")`
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    border-radius: 8px;
    object-fit: cover;
    z-index: 1;
`;

const Img = styled("img")`
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    user-select: none;
    border-radius: 8px;
    mix-blend-mode: multiply;
`;

const PaginationThumbnail = ({ active, media, handleClick }) => {
    const isSupportingWebp = useSelector(({ application }) => application.isSupportingWebp);
    const youTubeId = media.youtube?.split("/").pop() || "";
    const src = media.image
        ? stormSrc(media.image, { m: "crop", f: "webp", q: 70, w: 80, h: 80 }, isSupportingWebp)
        : imgixSrc(PLACEHOLDER, { fm: "avif", fit: "fill", fill: "solid", w: 80, h: 80 });

    return (
        <Button
            className={active ? "active" : ""}
            background={media.video ? `url(${media.video})` : media.youtube ? "rgba(0, 0, 0, 0.4)" : colors.neutral_50}
            onClick={handleClick}
        >
            {!(media.video || media.youtube) && <Img key={media.image} alt={media.title} src={src} loading="eager" />}
            {(media.video || media.youtube) && (
                <>
                    <VideoOverlay>
                        <StyledVideoPlayIcon />
                    </VideoOverlay>
                    {media.video && (
                        <Video key={media.video}>
                            <source src={`${media.video}#t=0.1`} type="video/mp4" />
                        </Video>
                    )}
                    {media.youtube && <Video as="img" src={`https://img.youtube.com/vi/${youTubeId}/0.jpg`} />}
                </>
            )}
        </Button>
    );
};

PaginationThumbnail.propTypes = {
    active: PropTypes.bool.isRequired,
    media: PropTypes.shape({
        title: PropTypes.string,
        video: PropTypes.string,
        youtube: PropTypes.string,
        image: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};

PaginationThumbnail.defaultProps = {
    onClick: null,
};

export default PaginationThumbnail;
